import React from "react";

// to sort list of records on basis of date in descending order
export function sortRecordsOnDate(listOfRecords: any[], dateAttribute: string){
    return listOfRecords.sort((a, b) => {
        const dateA = new Date(`${a[dateAttribute]}`).valueOf();
        const dateB = new Date(`${b[dateAttribute]}`).valueOf();
        if (dateA > dateB) {
            return -1;
        }
        return 1
    });
}

// Function to convert text from camelCase to TitelCase Example : charAt -> Char At
export const convertCamelCaseToTitleCase = (text: string) => {
    const result = text.replace(/([A-Z])/g, " $1");
    return result.charAt(0).toUpperCase() + result.slice(1);
};